import React, { useState } from "react";
import {
  Dialog,
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import emailjs from "@emailjs/browser";

const DownloadDialog = ({ open, onClose, fileUrl, title }) => {
  const [emailError, setEmailError] = useState("");
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Email validation
    if (!isBusinessEmail(form.email)) {
      setEmailError("Please use your company email (no Gmail/Yahoo allowed)");
      return;
    }

    setEmailError(""); // clear error
    setLoading(true);

    const templateParams = {
      name: form.name,
      email: form.email,
      phone: form.phone,
      company: form.company,
      report_name: title,
    };

    emailjs
      .send(
        "service_lspmqxc",
        "template_u8uonzr",
        templateParams,
        "ps-p6gBHKx9uv4TtB",
      )
      .then(() => {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setLoading(false);
        onClose();
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        alert("Something went wrong!");
      });
  };

  const isBusinessEmail = (email) => {
    const personalDomains = [
      "gmail.com",
      "yahoo.com",
      "outlook.com",
      "hotmail.com",
      "icloud.com",
      "live.com",
      "yopmail.com",
      "mail.com",
      "aol.com",
      "protonmail.com",
      "rediffmail.com",
      "zoho.com",
      "gmx.com",
      "yandex.com",
      "inbox.com",
      "fastmail.com",
      "hushmail.com",
      "tutanota.com",
      "mailfence.com",
      "runbox.com",
    ];

    const domain = email.split("@")[1];
    return domain && !personalDomains.includes(domain.toLowerCase());
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <Box sx={{ p: 3, borderRadius: "16px", position: "relative" }}>
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography variant="h6" fontWeight="bold" mb={1}>
          Download Report
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={2}>
          Fill in your details to download <b>{title}</b>
        </Typography>

        <form onSubmit={handleSubmit}>
          {/* Name */}
          <Typography fontSize={14}>Full Name *</Typography>
          <TextField
            fullWidth
            name="name"
            placeholder="John Doe"
            required
            onChange={handleChange}
            sx={{ mb: 2 }}
          />

          {/* Email */}
          <Typography fontSize={14}>Email Address *</Typography>
          <TextField
            fullWidth
            name="email"
            type="email"
            placeholder="john@company.com"
            required
            onChange={(e) => {
              handleChange(e);
              setEmailError(""); // clear error on typing
            }}
            error={!!emailError}
            helperText={emailError}
            sx={{ mb: 2 }}
          />

          {/* Phone */}
          <Typography fontSize={14}>Phone Number (optional)</Typography>
          <TextField
            fullWidth
            name="phone"
            placeholder="+91 98765 43210"
            onChange={handleChange}
            sx={{ mb: 2 }}
          />

          {/* Company */}
          <Typography fontSize={14}>Company Name *</Typography>
          <TextField
            fullWidth
            name="company"
            placeholder="Acme Inc."
            required
            onChange={handleChange}
            sx={{ mb: 3 }}
          />

          {/* Submit */}
          <Button
            fullWidth
            type="submit"
            variant="contained"
            startIcon={<DownloadIcon />}
            disabled={loading}
            sx={{
              backgroundColor: "#e86c2c",
              borderRadius: "10px",
              py: 1.2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#d65b1f",
              },
            }}
          >
            {loading ? "Sending..." : "Submit & Download"}
          </Button>
        </form>
      </Box>
    </Dialog>
  );
};

export default DownloadDialog;
